import React from 'react';
import { connect } from 'react-redux';
import VendorContent from 'containers/request/RequestContent/VendorContent';
import reqTypes from 'dictionaries/ReqTypes';
import {
  getVendorInitialTabs,
  getVendorECOTabs
} from 'helpers/RequestTabsHelper';
import { getChecklist } from 'helpers/ChecklistHelper';

const VendorRequestContent = ({ request }) => {
  const tabsInitial = getVendorInitialTabs(request);
  const tabsEco = getVendorECOTabs(request);
  const checkList = getChecklist(request);

  switch (request.type) {
    case reqTypes.initial:
      return <VendorContent tabs={tabsInitial} checkList={checkList} />;
    case reqTypes.eco:
      return <VendorContent tabs={tabsEco} checkList={checkList} />;
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(VendorRequestContent);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/VendorRequestContent.js